import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { Button, Drawer } from "antd";
import { MenuOutlined, GlobalOutlined } from "@ant-design/icons";

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const regions = [
    { name: "Americas", image: "/images/america-flag.png", param: "Americas" },
    { name: "Europe", image: "/images/europe_flag.png", param: "Europe" },
    { name: "ANZ", image: "/images/anz-flag.png", param: "ANZ" },
    { name: "Asia Pacific", image: "/images/apac-flag.png", param: "Asia_Pacific" },
    { name: "Middle East", image: "/images/middle-flag.png", param: "Middle_East" },
    { name: "Africa", image: "/images/africa-flag.png", param: "Africas" },
  ];

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    if (dropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownOpen]);

  return (
    <header className="salt-header">
      <nav className="salt-header__inner">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-auto">
              <Link to="/" className="salt-header__logo" aria-label="home">
                <span className="amplogo" style={{ display: 'inline-block', lineHeight: 0 }}>
                  <svg
                    width="200"
                    height="60"
                    viewBox="0 0 600 200"
                    xmlns="http://www.w3.org/2000/svg"
                    // style={{ maxHeight: 48, maxWidth: 160, verticalAlign: 'middle' }}
                    aria-label="Ampstek Logo"
                  >
                    <g transform="translate(50, 50)">
                      <path d="M 0,50 A 50,50 0 0,1 100,50" fill="#F26522"/>
                      <path d="M 0,50 A 50,50 0 0,0 100,50" fill="#1A1A1A"/>
                      <path
                        d="M 5,50 L 20,50 L 30,25 L 40,75 L 50,25 L 60,75 L 70,50 L 95,50"
                        stroke="white"
                        strokeWidth="6"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </g>
                    <g fontFamily="'Segoe UI', Roboto, Helvetica, Arial, sans-serif">
                      <text
                        x="170"
                        y="115"
                        fontSize="80"
                        fill="#ffffff"
                        // fill="rgb(242, 101, 34)"
                        fontWeight="bold"
                        letterSpacing="-1"
                      >
                        Amps
                        <tspan fontWeight="bold" fill="#ffffff">
                          Tek
                        </tspan>
                      </text>
                      {/* <text
                        x="175"
                        y="155"
                        fontSize="22"
                        fill="#ffffff"
                        fontWeight="600"
                        letterSpacing="2"
                        style={{ textTransform: "uppercase" }}
                      >
                        Enable • Engage • Collaborate
                      </text> */}
                    </g>
                  </svg>
                </span>
              </Link>
            </div>

            <div className="col-auto ms-auto d-none d-lg-flex align-items-center salt-header__desktop-nav">
              <div className="salt-header__actions">
              <Link to="/careers">
                  <Button className="salt-pill salt-pill--pink">Careers</Button>
                </Link>
                {/* <Button
                  className="salt-pill salt-pill--pink"
                  onClick={() => window.dispatchEvent(new CustomEvent("open-contact-drawer"))}
                >
                  Find Talent
                </Button> */}
              </div>
              <nav className="salt-header__nav">
              <Link to="/about-us" className="salt-header__link">
                  About Us
                </Link>
                <Link
                  to={{ pathname: "/", hash: "#latest-insights" }}
                  className="salt-header__link"
                >
                  Insights
                </Link>
                <Link to="/blogs" className="salt-header__link">
                  Blogs
                </Link>
                <Link
                  to={{ pathname: "/", hash: "#continents" }}
                  className="salt-header__link"
                >
                  Meet Ampstek
                </Link>
                {/* <Link
                  to={{ pathname: "/", hash: "#solutions" }}
                  className="salt-header__link"
                >
                  Solutions
                </Link> */}
               
                <Link to="/contact-us" className="salt-header__link">
                  Contact Us
                </Link>
              
                <div className="salt-header__globe-wrapper" ref={dropdownRef}>
                  <button 
                    className="salt-header__globe" 
                    aria-label="Select region"
                    onClick={() => setDropdownOpen(!dropdownOpen)}
                  >
                    <GlobalOutlined />
                  </button>
                  <div className={`salt-header__countries-dropdown ${dropdownOpen ? 'salt-header__countries-dropdown--open' : ''}`}>
                    <div className="salt-header__countries-grid">
                      {regions.map((region) => (
                        <Link
                          key={region.name}
                          to={`/contact-us?global=${encodeURIComponent(region.param)}`}
                          className="salt-header__country-item"
                          onClick={() => {
                            setMobileMenuOpen(false);
                            setDropdownOpen(false);
                          }}
                        >
                          <div className="salt-header__country-flag">
                            <img src={region.image} alt={`${region.name} flag`} />
                          </div>
                          <span className="salt-header__country-name">{region.name}</span>
                        </Link>
                      ))}
                    </div>
                  </div>
                </div>
              </nav>
            </div>

            <div className="col-auto ms-auto d-lg-none">
              <Button
                type="text"
                icon={<MenuOutlined />}
                className="salt-header__mobile-toggle"
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              />
            </div>
          </div>
        </div>
      </nav>

      <Drawer
        title="Menu"
        placement="right"
        onClose={() => setMobileMenuOpen(false)}
        open={mobileMenuOpen}
        className="salt-header__mobile-drawer"
      >
        <div className="salt-header__mobile-menu">
          <Link
            to={{ pathname: "/", hash: "#latest-insights" }}
            className="salt-header__mobile-link"
            onClick={() => setMobileMenuOpen(false)}
          >
            Insights
          </Link>
          <Link
            to={{ pathname: "/", hash: "#continents" }}
            className="salt-header__mobile-link"
            onClick={() => setMobileMenuOpen(false)}
          >
            Meet Ampstek
          </Link>
          <Link
            to={{ pathname: "/", hash: "#solutions" }}
            className="salt-header__mobile-link"
            onClick={() => setMobileMenuOpen(false)}
          >
            Solutions
          </Link>
          <Link 
            to="/about-us" 
            className="salt-header__mobile-link"
            onClick={() => setMobileMenuOpen(false)}
          >
            About Us
          </Link>
          <a href="#" className="salt-header__mobile-link">
            Candidates
          </a>
          <Link 
            to="/contact-us" 
            className="salt-header__mobile-link"
            onClick={() => setMobileMenuOpen(false)}
          >
            Contact Us
          </Link>
          <div className="salt-header__mobile-actions">
            <Link 
              to="/careers"
              onClick={() => setMobileMenuOpen(false)}
              style={{ width: '100%' }}
            >
              <Button 
                className="salt-pill salt-pill--blue salt-header__mobile-btn"
                block
              >
                Careers
              </Button>
            </Link>
            <Button
              className="salt-pill salt-pill--pink salt-header__mobile-btn"
              block
              onClick={() => {
                setMobileMenuOpen(false);
                window.dispatchEvent(new CustomEvent("open-contact-drawer"));
              }}
            >
              Find Talent
            </Button>
          </div>
        </div>
      </Drawer>
    </header>
  );
}
